<template>
  <div class="main-header">
    <img class="logo-img" :src="logo"/>
    <el-dropdown class="current-user" v-if="userName">
      <div>
        {{ userName }}
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="handleCommand">{{ $t('lang.Log out') }}</el-dropdown-item>
        <el-dropdown-item @click.native="dialogVisiblepassword = true">{{ $t('lang.Change the password') }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- <div class="dfe languageBox">
      <el-button :class="{active:$i18n.locale == 'en'}" @click="ENGCheck('en')">ENG</el-button>
      <el-button :class="{active:$i18n.locale == 'zh'}" @click="ENGCheck('zh')">中文</el-button>
    </div> -->
    <el-dialog
      :title="$t('lang.Change the password')"
      :visible.sync="dialogVisiblepassword"
      width="30%"
    >
      <el-form :model="forgetForm" :rules="forgetRules" ref="forgetForm">
        <el-form-item prop="userName">
          <el-input @keyup.native="forgetForm.userName = forgetForm.userName.replace(/[^\w\.\/]/ig,'')"
                    v-model="forgetForm.userName" :placeholder="$t('lang.Please enter the account')"
                    maxlength="50"></el-input>
        </el-form-item>
        <el-form-item prop="passWord">
          <el-input @keyup.native="forgetForm.passWord = forgetForm.passWord.replace(/[^\w\.\/]/ig,'')"
                    type="password" v-model="forgetForm.passWord" :placeholder="$t('lang.Please input new password')"
                    maxlength="16"></el-input>
        </el-form-item>
        <el-form-item prop="rePassWord">
          <el-input type="password" v-model="forgetForm.rePassWord"
                    :placeholder="$t('lang.Please_input_a_password_again')"
                    maxlength="16"></el-input>
        </el-form-item>
        <div class="confirmBtnBox">
          <el-button type="primary" @click="chargePassWord('forgetForm')">{{ $t('lang.Confirm') }}</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {chargePassWord} from '@/api/login.js'
import Utils from "../../utils/utils";
import RongyiLogo from "../../assets/images/img-logo.png";
import GuoyuLogo from "../../assets/images/guoyu-logo.jpg";
import HiliLogo from "../../assets/images/img-logo-hili.jpg";

export default {
  name: "mainHeader",
  data() {
    return {
      dialogVisiblepassword: false,
      logo: '',
      userInfo: {},
      // 忘记密码
      forgetForm: {
        userName: '',
        passWord: '',
        rePassWord: ''
      },
      forgetRules: {
        userName: {required: true, message: this.$t('lang.Please enter the account'), trigger: 'blur'},
        rePassWord: {required: true, message: this.$t('lang.Please input new password'), trigger: 'blur'},
        passWord: {required: true, message: this.$t('lang.Please_input_a_password_again'), trigger: 'blur'},
      },
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    userName() {
      return localStorage.getItem('userName');
    }
  },
  mounted() {
    // let domain = Utils.getDomain();
    // console.log(domain == "iot.lititi.com"||domain == 'hailixinnengyuan.com' || domain == 'leasehold-test.lititi.com'||domain=='leasehold-dev.lititi.com');
    // let self = this;
    // this.$http.post("/client/sms/userInformation").then(function(response) {
    //   let res = response.data;
    //   if (res.mdata.userInformationDto) {
    //     self.$store.dispatch(
    //       "SET_CURRENT_USER",
    //       res.mdata.userInformationDto.loginPhone
    //     );
    //   }
    // });
    // this.getUserInfo()
  },
  methods: {
    // 切换语言
    ENGCheck(val) {
      this.$i18n.locale = val;
      this.enFlag = !this.enFlag;
    },
    // 忘记密码确定
    chargePassWord(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        if (this.forgetForm.passWord.length < 6) {
          this.$message.error(this.$t('lang.Password at least 6 characters'));
          return false;
        }
        if (this.forgetForm.passWord != this.forgetForm.rePassWord) {
          this.$message.error(this.$t('lang.The two passwords do not match'));
          return false;
        }
        const params = {...this.forgetForm};
        params.passWord = this.$md5(params.passWord);
        params.rePassWord = this.$md5(params.rePassWord);
        const res = await chargePassWord(params);
        console.log(res, '修改密码返回');
        // if(res. == ){
        //   this.$message.success('修改成功');
        // }
        this.dialogVisiblepassword = false;
        // this.onLoginBtnClick();更改密码接口
      });
    },
    // 退出登录
    handleCommand() {
      localStorage.removeItem('userName');
      sessionStorage.removeItem('queryAuthorityArr')
      // this.$store.commit('clearUserName');
      this.$router.push('/');
      // let self = this;
      this.$http
        .post("/logout")
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              message: res.message || this.$t('lang.Exit failure'),
              type: "error"
            });
            return;
          }
          self.$store.dispatch("CLEAR_CURRENT_USER");
          self.$router.push("loginPage");
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    // login() {
    //   this.$router.push("loginPage");
    // },
    // 修改密码
    goRentBattery() {

      // const {origin} = location
      // // window.location.href = `${origin}/leaseholdMgmt`
      // window.location.href = `${origin}/leaseholdMgmt/rentEleCharts`

    },
    async getUserInfo() {
      const res = await this.$http.get('/getUserInfo')
      this.userInfo = res.data.mdata
    }
  }
};
</script>

<style lang="scss" scoped>
.languageBox {
  margin-right: 40px;
}

.main-header {
  height: 100%;
  width: 100%;
  overflow: hidden;

  .logo-img {
    height: 35px;
    overflow: hidden;
    margin: 11px 62px;
  }

  .current-user {
    float: right;
    height: 18px;
    font-size: 16px;
    color: #4cb132;
    margin: 20px 66px;
  }

  .pointer {
    cursor: pointer;
  }
}

.active {
  background: #4CB132;
  color: #fff;
  border: 1px solid #4CB132;
}
</style>



// WEBPACK FOOTER //
// src/components/common/mainHeader.vue